import * as Yup from "yup";
import { BoletagemSchema } from "../boletagem/schema";

export class BoletagemComentarioSchema {
  public static createForm() {
    const createFormShape = {
      comentario: Yup
        .string()
        .min(1, "Comentário deve ter pelo menos 1 caracter")
        .max(500, "Comentário não pode ter mais de 500 caracteres"),
      boletagem: Yup
        .object()
        .shape({
          id: BoletagemSchema.id()
            .required("Boletagem é obrigatório"),
        }),
    };

    return Yup.object().shape(createFormShape);
  }
}
